export const INITIAL_SIGNATORY_DETAILS = {
  personalNumber: '',
  fullName: '',
  email: '',
  incharge: false,
};

export const INITIAL_ADMIN_DETAILS = {
  personalNumber: '',
  fullName: '',
  email: '',
};

export const INITIAL_CONTACT_PEOPLE = {
  system: '',
  personalNumber: '',
  name: '',
  email: '',
};

export const INITIAL_ADDRESS_DETAILS = {
  city: '',
  country: '',
  postcode: '',
  street: '',
};

export const INITIAL_COMPANY_DETAILS = {
  organizationNumber: '',
  name: '',
  status: 'Active',
};

export const INITIAL_CONSULANTS_DETAILS = {
  fullName: '',
  personalNumber: '',
  email: '',
}

export const INITIAL_INIVITATION_EMAIL_SETTING = '3'

export const FORM_INITIAL_VALUES = {
  companyDetails: INITIAL_COMPANY_DETAILS,
  address: INITIAL_ADDRESS_DETAILS,
  contractEffectiveFrom: '',
  contractEmail: '',
  invoiceCostCenter: '',
  authorizedSignatory: [{ _id: `${Math.random()}`, ...INITIAL_SIGNATORY_DETAILS, incharge: true },
  { _id: `${Math.random()}`, ...INITIAL_SIGNATORY_DETAILS },],
  combinations: [],
  admins: [],
  consultants: [],
  consultant: {},
  salaryContactPeople: { ...INITIAL_CONTACT_PEOPLE },
  accountingContactPeople: { ...INITIAL_CONTACT_PEOPLE },
  collectiveAgreements: [],
  invitationEmail: INITIAL_INIVITATION_EMAIL_SETTING,
  deployment: { systemDeploymentMonth: null, employeeInvitationSendOuts: null },
  integration: {},
};

export const ACCOUNTING_SYSTEM_OPTIONS = [
  { label: 'Fortnox', value: 'fortnox' },
  { label: 'Visma eEkonomi', value: 'visma_eekonomi' },
  { label: 'Bokio', value: 'bokio' },
  { label: 'SpeedLedger', value: 'speedledger' },
  { label: 'Hogia Bokföring (Björn Lundén)', value: 'hogia_bokforing_bjorn_lunden' },
  { label: 'Spiris', value: 'spiris' },
  { label: 'Wint', value: 'wint' },
  { label: 'Acconomy', value: 'acconomy' },
  { label: 'Dooer', value: 'dooer' },
  { label: 'SPCS Administration', value: 'spcs_administration' },
  { label: 'Zenconomy', value: 'zenconomy' },
  { label: 'Procountor', value: 'procountor' },
];

export const SALARY_SYSTEM_OPTIONS = [
  { label: 'Visma Lön Smart', value: 'visma_lon_smart' },
  { label: 'Fortnox Lön', value: 'fortnox_lon' },
  { label: 'Hogia Lön', value: 'hogia_lon' },
  { label: 'SD Worx Lön', value: 'sd_worx_lon' },
  { label: 'Björn Lundén Lön', value: 'bjorn_lunden_lon' },
  { label: 'POL (Payroll Online)', value: 'pol_payroll_online' },
  { label: 'Heroma', value: 'heroma' },
  { label: 'Flex Lön', value: 'flex_lon' },
  { label: 'Kontek Lön', value: 'kontek_lon' },
  { label: 'Agda PS', value: 'agda_ps' },
  { label: 'Crona Lön', value: 'crona_lon' },
  { label: 'Collectum', value: 'collectum' },
  { label: 'Payap', value: 'payap' },
  { label: 'Kleer Payroll', value: 'kleer_payroll' },
  { label: 'Timezynk', value: 'timezynk' },
  { label: 'Primula', value: 'primula' },
  { label: 'eCompanion (Tietoevry)', value: 'ecompanion_tietoevry' },
];

export const HR_SYSTEM_OPTIONS = [
  { label: 'Sympa', value: 'sympa' },
  { label: 'Remote', value: 'remote' },
  { label: 'HiBob', value: 'hibob' },
  { label: 'BambooHR', value: 'bamboohr' },
  { label: 'Deel', value: 'deel' },
  { label: 'Hailey HR', value: 'hailey_hr' },
  { label: 'AlexisHR', value: 'alexishr' },
  { label: 'Heartpace', value: 'heartpace' },
  { label: 'Boardon', value: 'boardon' },
  { label: 'SAP SuccessFactors', value: 'sap_successfactors' },
  { label: 'Workday', value: 'workday' },
  { label: 'NetSuite ERP (HR-modul)', value: 'netsuite_erp_hr' },
  { label: 'Primula', value: 'primula' },
  { label: 'eCompanion (Tietoevry)', value: 'ecompanion_tietoevry' },
  { label: 'Visma.net HRM & Payroll', value: 'visma_net_hrm_payroll' },
  { label: 'Simployer', value: 'simployer' },
  { label: 'Flex HRM', value: 'flex_hrm' },
];